import { request } from 'src/api/request';

export const getTopProviders = async ({ providerId, queryParams }) => {
  if (!providerId) return;
  return await request({
    url: `/v1/providers/${providerId}/top-providers-at-site${queryParams}`,
    method: 'GET',
  });
};
